export const sampleMessages = state => state.sampleMessages
export const sampleStatus = state => state.status
